import React from "react";
import PropTypes from "prop-types";
import { DeleteIcon } from "wm-graphics";
import "./SelectedOption.scss";

const ENTER_KEY = "Enter";

export class SelectedOption extends React.Component {
  static defaultProps = {
    requireSelect: false,
  };

  static propTypes = {
    children: PropTypes.node,
    value: PropTypes.any.isRequired,
    id: PropTypes.number,
    onUnselectClick: PropTypes.func.isRequired,
    requireSelect: PropTypes.bool,
  };

  onClick = (event) => {
    event.stopPropagation();
    const { onUnselectClick, value } = this.props;

    onUnselectClick(value);
  };

  onKeyDown = (event) => {
    if (event.key === ENTER_KEY) {
      this.onClick(event);
    }
  };

  render() {
    const { children, id, requireSelect, value } = this.props;

    return (
      <div
        className="SelectedOption"
        id={id}
        value={value}
        onClick={this.onClick}
        onKeyDown={this.onKeyDown}
        role="button"
        tabIndex={0}
      >
        <div className="SelectedOption__children">{children}</div>
        <div className="SelectedOption__unselect">
          {!requireSelect && <DeleteIcon width="10px" height="10px" />}
        </div>
      </div>
    );
  }
}

export default SelectedOption;
